import { render, staticRenderFns } from "./mascote.vue?vue&type=template&id=c945bf8e"
import script from "./mascote.vue?vue&type=script&lang=js"
export * from "./mascote.vue?vue&type=script&lang=js"
import style0 from "./mascote.vue?vue&type=style&index=0&id=c945bf8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports